// @ts-check
import { LBButton } from '@linearb/buzz';
import { Flex } from 'components/base/layout-components';

export const Actions = ({ handleSave, isValid }) => {
  return (
    <Flex justify='flex-end' pt='small'>
      <LBButton
        onClick={handleSave}
        size='lg'
        disabled={!isValid}
        data-testid='edit-custom-pm-modal-save-button'
        data-cy='edit-custom-pm-modal-save-button'
      >
        Save
      </LBButton>
    </Flex>
  );
};
